module.exports = __webpack_public_path__ + "img/header_logo.5cde64b7.png";